// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x7rcXU3b{margin-bottom:15px}`, "",{"version":3,"sources":["webpack://./src/fsd/entities/cabinet/ui/CabinetModal/CabinetModal.module.scss"],"names":[],"mappings":"AAAA,UACE,kBAAA","sourcesContent":[".modalTitle {\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalTitle": `x7rcXU3b`
};
export default ___CSS_LOADER_EXPORT___;
